/**
* Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
* Created Date: Sunday, 24th March 2019
* 
* Google Maps API
* 
* Reference URLs
* types: https://developers.google.com/places/web-service/autocomplete#place_types
* status: https://developers.google.com/places/web-service/autocomplete#place_autocomplete_status_codes
* data: https://developers.google.com/places/web-service/place-data-fields
* 
* 03/26/2019 - Not using location biasing
* 
* Autocomplete Result Fields: status, prediction: { description, id, matched_substrings{}, place_id, reference, terms{}, types{} }
* Place Details Results can vary depending on the type of details requested.
* Example Here: https://developers.google.com/places/web-service/details#fields
*
* Data Groups Used:
* address_component - Address Fields
* formatted_address - Formatted user friendly address string
* name - address name
* formatted_phone_number - Phone Number
* website - Website URL
* 
*/

class GoogleMaps {
  constructor() {
    // Primary Google API Services
    this.maps = window.google.maps;
    this.places = window.google.maps.places;
    this.placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
    this.geocoder = new window.google.maps.Geocoder();
    this.autocompleteService = new window.google.maps.places.AutocompleteService();
    this.autocomplete = new window.google.maps.places.Autocomplete(document.createElement('input'));
  }
}
export default GoogleMaps;
